import React, { ComponentClass } from "react";
import { useClassNames } from "./useClassNames";

export function withClassNames<C extends ComponentClass<any>>(
  WrappedComponent: C
): C {
  return (React.forwardRef(
    (props, ref: React.LegacyRef<React.Component<any>>) => {
      const teaClassNames = useClassNames();
      return React.createElement(WrappedComponent, {
        ...props,
        ref,
        teaClassNames,
      });
    }
  ) as any) as C;
}
